<template>
  <div>
    <div v-for="app in systemApplications" :key="app.id" class="sysapp-container" @click="onSelect(app)">
      <img class="sysapp-image" :src="getImage(app.get('modxId'))" />
      <div class="sysapp-title">
        <span>{{ app.get('name') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import StoreModules from '../../store/store-modules';
import SystemApplicationDetailModal from '../../components/modals/SystemApplicationDetailModal';
export default {
  name: 'SystemApplicationsView',
  components: {},
  props: {},
  created() {
    this.loadSystemApplications();
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(StoreModules.SYSTEM_APPLICATIONS, ['systemApplications']),
  },
  methods: {
    ...mapActions(StoreModules.SYSTEM_APPLICATIONS, ['loadSystemApplications']),
    getImage(id) {
      try {
        return require('@/assets/images/system-applications/apps_' + id + '.jpg');
      } catch (e) {
        return null;
      }
    },
    onSelect(app) {
      this.$modal.show(SystemApplicationDetailModal, { systemApp: app }, { height: 'auto', width: '350px' });
    },
  },
};
</script>

<style lang="scss" scoped>
.sysapp-image {
  object-fit: cover;
  width: 100%;
  height: 25vh;
  transition: all 0.25s ease;
  border-bottom: 10px solid;
  cursor: pointer;
  filter: grayscale(60%);
  &:hover {
    filter: grayscale(20%) brightness(120%);
  }
}
.sysapp-container {
  position: relative;
}

.sysapp-title {
  position: absolute;
  top: 25px;
  left: 15px;
  margin-right: 1rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  backdrop-filter: blur(40%);
  padding: 0.5rem;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: left;
  word-break: break-word;
}

.sysapp-systems {
  position: absolute;
  display: grid;
  grid-column-gap: 1rem;
  grid-template-columns: repeat(3, 1fr);
  top: 100px;
  left: 15px;
  transition: all 0.25s ease;
  text-align: left;
  overflow: auto;
  width: 90%;
  height: 80%;
}
.sysapp-entry {
  margin-bottom: 5px;
  background: rgba(255, 255, 255, 0.7);
  padding: 10px;
  cursor: pointer;
  transition: all 0.25s ease;
  font-size: 1.1rem;

  &:hover {
    background: rgba(255, 255, 255, 0.9);
  }
}
</style>
